import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashTopSellerProductsThunk } from "../../../store/thunks/dashboardThunk";
import moment from "moment";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import { AllRangePicker } from "../../../components/atoms/formFields/rangePicker/allRangePicker";
import AllToolTip from "../../../components/atoms/Tooltip/AllToolTips";

const TopSellingProducts = (format) => {
  const dispatch = useDispatch();

  const { loading, error, list } = useSelector(
    (state) => state?.dashTopSeller || {}
  );
  const [filter, setFilter] = useState({
    fromDate: "",
    toDate: "",
    inventoryId: null,
  });
  useEffect(() => {
    dispatch(
      dashTopSellerProductsThunk({
        paginationFilter: { limit: 5, offset: 0, order: "DESC" },
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        inventoryId: filter.inventoryId,
      })
    );
  }, [dispatch, filter]);
  return (
    <div className="card card-custom h-100">
      <div className="bg-gray-700 border-1 border-bottom card-header min-h-auto py-3">
            <h4
          className="card-label font-weight-bold text-white"
          style={{ margin: " 7px 0" }}
        >
          Top Selling Products
          <AllToolTip text="Shows the products with the highest unit ordered based on selected date range" />
        </h4>
        <div className="card-toolbar align-items-start m-lg-0 m-md-0">
          <AllRangePicker
            disabledDate={(current) => moment().add(0, "days") <= current}
            onChange={(value) => {
              if (value) {
                setFilter({
                  ...filter,
                  fromDate: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                  toDate: moment(value[1]["$d"]).format("DD/MM/YYYY"),
                });
              } else {
                setFilter({
                  ...filter,
                  fromDate: null,
                  toDate: null,
                });
              }
            }}
          />
        </div>
      </div>
      <div className="card-body p-0">
        <div className="table-responsive">
          <div className="table-responsive">
            <table className="table table-bordered m-0 border radius-remove all_domain_table">
              <thead>
                <tr>
                  <th className="width">Sr. No</th>
                  <th className="width">Product Name</th>
                  <th className="width">Orders</th>
                  <th className="width">Revenue</th>
                </tr>
              </thead>
              <tbody className="font-weight-bold">
                {loading ? (
                  <tr>
                    <td colSpan={8} className="text-center py-5">
                      <TableLoader />
                    </td>
                  </tr>
                ) : list?.length > 0 ? (
                  list.map((dataList, index) => {
                    return (
                      <tr className="greyBackground" key={index.toString()}>
                        <td className="font-weight-bold">
                          {index +1}
                          {/* <div className="symbol symbol-70">
                            <img
                              src={dataList.imageUrl}
                              className="max-w-70px rounded-0 w-100 reviews_product_image"
                              style={{ objectFit: "contain" }}
                              alt=""
                            />
                          </div> */}
                        </td>
                        <td className="font-weight-bolder text-left">
                          {dataList?.productName?.en} - {dataList?.variant}
                        </td>
                        <td className="">{dataList?.totalSale}</td>
                        <td className="">{dataList?.revenue}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={4}>No Data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSellingProducts;
